/**
 * Locale-aware replacements for `next/link` and `next/navigation`.
 *
 * Import these instead of the Next.js originals — the signatures are
 * identical, but these keep the active locale in the URL. A plain
 * `next/link` inside `/en/...` silently drops the visitor back to Persian.
 *
 * See docs/I18N_GUIDE.md §5.
 */
export { Link, useRouter } from './navigation-client'
export { redirect, usePathname, getPathname } from './navigation-base'
